"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var resize_observer_polyfill_1 = require("resize-observer-polyfill");
/**
 * A hook wrapper around a resize observer (using a polyfill because it's not widely supported natively)
 * to watch a node for when it changes, and returns an object with its bounds accordingly.
 *
 * Probably a better API than useGetDimensions, I may go through at some point and change existing code to
 * use this.
 *
 *    @example
 *    // Using react-spring as an example for a drawer that show/hides its contents
 *    // according to an isOpen prop. The contents can be of variable height, so we have to
 *    // measure that to have an appropriate transition from 0 height to the max height.
 *    const [bind, { width, height }] = useMeasure();
 *    const drawerProps = useSpring({
 *      width,
 *      height: isOpen ? height : 0,
 *      clamp: "true",
 *    });
 *
 *    return (
 *      // Animated div with the dimensions from useMeasure.
 *      <animated.div style={{ overflow: "hidden", ...drawerProps }}>
 *        // The height/width of the transition are set by measuring the
 *        // dimensions of a div containing the drawer's children.
 *        <div style={{ display: "inline-block" }} {...bind}>
 *          {children}
 *        </div>
 *      </animated.div>
 *    )
 *
 */
exports.useMeasure = function () {
    var ref = react_1.useRef();
    var _a = react_1.useState({ left: 0, top: 0, width: 0, height: 0 }), bounds = _a[0], set = _a[1];
    var observer = react_1.useState(function () { return new resize_observer_polyfill_1.default(function (_a) {
        var entry = _a[0];
        return set(entry.contentRect);
    }); })[0];
    react_1.useEffect(function () {
        // Add the observer.
        if (ref.current)
            observer.observe(ref.current);
        // Clean up.
        return function () {
            observer.disconnect();
        };
    }, [observer]);
    return [{ ref: ref }, bounds];
};
